import pino from 'pino';

export const logger = pino({
  level: process.env.SUDS_LOG_LEVEL || 'info',
  prettyPrint: process.env.SUDS_ENV !== 'production',
});
